import type { HeatmapCellValue, HeatmapRange } from "./types";

export const HEATMAP_BUCKET_CLASSES = [
  "bg-core-secondary-blue-50 text-lds-foreground-muted",
  "bg-core-secondary-blue-100 text-lds-foreground-secondary",
  "bg-core-secondary-blue-200 text-lds-foreground-primary",
  "bg-core-secondary-blue-300 text-lds-foreground-primary",
  "bg-core-secondary-blue-400 text-lds-foreground-inverse",
  "bg-core-secondary-blue-500 text-lds-foreground-inverse",
  "bg-core-secondary-blue-600 text-lds-foreground-inverse",
  "bg-core-secondary-blue-700 text-lds-foreground-inverse",
  "bg-core-secondary-blue-800 text-lds-foreground-inverse",
];

export const formatHeatmapValue = (value: HeatmapCellValue): string => {
  if (value === null) {
    return "";
  }

  return String(value);
};

export const getHeatmapRange = (values: HeatmapCellValue[][]): HeatmapRange => {
  let min = Number.POSITIVE_INFINITY;
  let max = Number.NEGATIVE_INFINITY;

  values.forEach((row) => {
    row.forEach((value) => {
      if (value === null) {
        return;
      }

      if (value < min) min = value;
      if (value > max) max = value;
    });
  });

  if (!Number.isFinite(min) || !Number.isFinite(max)) {
    return { max: 0, min: 0 };
  }

  return { max, min };
};

const getHeatmapBucketIndex = (value: number, range: HeatmapRange): number => {
  const { max, min } = range;

  if (min === max) {
    return Math.floor(HEATMAP_BUCKET_CLASSES.length / 2);
  }

  const normalized = (value - min) / (max - min);

  if (normalized >= 1) {
    return HEATMAP_BUCKET_CLASSES.length - 1;
  }

  if (normalized <= 0) {
    return 0;
  }

  return Math.min(HEATMAP_BUCKET_CLASSES.length - 1, Math.floor(normalized * HEATMAP_BUCKET_CLASSES.length));
};

export const getHeatmapCellClass = (value: HeatmapCellValue, range: HeatmapRange): string => {
  if (value === null) {
    return "bg-white";
  }

  const bucketIndex = getHeatmapBucketIndex(value, range);
  return HEATMAP_BUCKET_CLASSES[bucketIndex];
};
export const getHeatmapInteractionCellClass = (): string => "bg-core-tangerine-200 text-core-tangerine-900";
